import { Toolbar, CircularProgress } from "@material-ui/core";
import RecursiveMenu from "./RecursiveMenu";

const MainMenu = ({ menu, classes, parseTitle, loading }) => (
  <Toolbar className={classes.mainMenu}>
    {loading && !menu && (
      <CircularProgress color="secondary" className={classes.circularProgress} />
    )}
    {menu && <RecursiveMenu items={menu} classes={classes} parseTitle={parseTitle} />} 
  </Toolbar>
);

export default MainMenu;
